import { useEffect } from "react";

/**
 * Dynamically injects a Google Font <link> tag into the document head
 * when the layout mounts, and cleans up when it unmounts.
 *
 * @example
 * useDynamicFont("https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap");
 */
export function useDynamicFont(fontHref: string) {
  useEffect(() => {
    if (!fontHref) return;

    const existing = document.querySelector(`link[href="${fontHref}"]`);
    if (existing) return; // Already loaded

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = fontHref;
    document.head.appendChild(link);

    return () => {
      // Optional cleanup: remove font link when layout unmounts
      document.head.removeChild(link);
    };
  }, [fontHref]);
}
